module.exports = __webpack_public_path__ + "static/wordpress8-bc79e09a52c297708c99770057c44e67.png";